module.exports = __webpack_public_path__ + "img/alain_fournier_cover.369edf25.jpg";